import PantryStackLogo from "../PantryStackLogo/PantryStackLogo";
import { useTenant } from "../../tenant/useTenant";
import "./TenantBrandCss.css";
import { useState, useEffect } from "react";
import { resolveImageUrl } from "../../utils/ImageUrl";

interface TenantBrandProps {
  Compact?: boolean;
  Inverse?: boolean;
}

export default function TenantBrand({
  Compact = false,
  Inverse = false,
}: TenantBrandProps) {
  const { Tenant } = useTenant();
  const [failed,setFailed]=useState(false);
  useEffect(()=>setFailed(false),[Tenant?.LogoUrl]);

  if (!Tenant?.LogoUrl || failed) {
    return <PantryStackLogo Compact={Compact} Inverse={Inverse} />;
  }

  return (
    <div className={`tenant-brand ${Inverse ? "tenant-brand-inverse" : ""}`}>
      <img
        src={resolveImageUrl(Tenant.LogoUrl)}
        onError={()=>setFailed(true)}
        alt={`${Tenant.BusinessName} logo`}
      />
      {!Compact && <strong>{Tenant.BusinessName}</strong>}
    </div>
  );
}
